/**
* Library for the flexygo.localization.
*
* @class flexygo.localization
*/

namespace flexygo.localization {

    /**
        * Translates java script strings to profile default language.
        * If no translation is found it will display fall back language en-gb
        * @method translate
        * @param {string} key - language variable string.
        * @return {string} - returns translated string
    */
    export function translate(key: string): string {

        var text:string = null;

        try {
            text = key.split('.').reduce((object: object, index: string) => object ? object[index] : null, flexygo.culture[flexygo.profiles.langKey.toLowerCase()]);
        } catch (ex) { }

        if (text == null) {
            try {
                text = key.split('.').reduce((object: object, index: string) => object ? object[index] : null, flexygo.culture.engb);
            } catch (ex) { }
        }

        if (text == null) {
            text = key;
        }

        return text;
    }

    /**
          * Initializes date plugin moment.locale with correct language.
          * @method init
          */
    export function init(): void {
        if (navigator && navigator.language) {
            moment.locale(navigator.language);
        }
        else {
            moment.locale('es');
        }
    }


}


